import React, { useEffect, useState } from 'react'
import HttpClient from '../../utils/HttpClient';
import toast from 'react-hot-toast';
import Loader from '../../Loader/Loader';
import { Modal, ModalHeader, ModalBody, Button, Table } from 'reactstrap';
import { FaEdit, FaEye, FaTimes } from 'react-icons/fa';
const Carrer = () => {

    const carrerInit = {
        heading: "",
        description: "",
        image: ""
    }
    const [carrerData, setCarrerData] = useState(carrerInit)
    const [imageFile, setimageFile] = useState(null);
    const [loading, setLoading] = useState(false);

    const [carrerGetData, setCarrerGetData] = useState({});
    const [modalOpen, setModalOpen] = useState(false);
    const [isEdit, setIsEdit] = useState(false)
    const [sectionID, setSectionId] = useState("")


    const toggleModal = () => setModalOpen(!modalOpen);

    // Handle View Details
    const handleViewDetails = () => {
        toggleModal();
    }


    // Handle Edit
    const handleEdit = () => {
        setIsEdit(true)
        setCarrerData({
            heading: carrerGetData?.heading || '',
            description: carrerGetData?.description || '',
            image: carrerGetData?.image || ''
        });
        setimageFile(carrerGetData?.image)
    };

    // >>>>Handle Carrer Input Change Data<<<<
    const handleCarrerChange = (e) => {
        const { name, value } = e.target;
        setCarrerData({ ...carrerData, [name]: value })
    }

    // >>>>Handle Image<<<<
    const handleImage = async (e) => {
        const file = e.target.files[0];
        if (!file) {
            return;
        }

        if (file.size > 5 * 1024 * 1024) {
            toast.error("Image size must be less than 5 MB");
            return;
        }

        let formData = new FormData();
        formData.append("image", file);
        setLoading(true)
        const res = await HttpClient.fileUplode("image-upload", "POST", formData);
        if (res && res.status) {
            setLoading(false)
            toast.success("Image Uploaded Successfully");
            setimageFile(res?.url);
            setCarrerData({ ...carrerData, image: res?.url })
        } else {
            setLoading(false)
            setimageFile(null)
            toast.error(res?.message || "Something Wrong");
        }
    };

    // >>>Handle Removing Image<<< 
    const handleRemoveImage = () => {
        setimageFile(null);
        setCarrerData({ ...carrerData, image: "" })
        document.getElementById("image").value = "";
    };

    // Fetch Carrer Data
    const fetchCarrerData = async () => {
        setLoading(true);
        const res = await HttpClient.requestData("home", "GET");
        if (res && res?.status) {
            setLoading(false);
            setSectionId(res?.data?._id)
            setCarrerGetData(res.data ? res?.data?.career : {});
        } else {
            setLoading(false);
            setCarrerGetData({});
        }
    }

    // >>>>Handle Submit Data<<<<
    const handleSubmit = async (e) => {
        e.preventDefault()
        const data = {
            career: carrerData
        }
        console.log("carrerData", data)
        // return
        setLoading(true)
        const res = await HttpClient.requestData(`home/${sectionID}`, "PUT", data);
        if (res && res?.status) {
            setLoading(false)
            toast.success(res?.message || "Data updated successfully.!");
            setCarrerData(carrerInit)
            setimageFile(null)
            setIsEdit(false)
            fetchCarrerData()
            document.getElementById("image").value = "";
        } else {
            setLoading(false)
            return toast.error(res?.message || "Something went wrong...!")
        }
    }

    useEffect(() => {
        fetchCarrerData()
    }, [])
    return (
        <div className="d-flex justify-content-end">
            {loading && <Loader />}
            <div className="form-header mx-2">
                <section className="piechartsBox_area">

                    {isEdit &&
                        <>
                            <form onSubmit={handleSubmit}>
                                {/* Career */}
                                <div className='p-2 mb-4' style={{ border: "1px solid #eee" }}>
                                    <h2 >Update Careers</h2>
                                    <div className="form-group section" style={{ border: "1px solid #ccc" }}>
                                        <div className="form-group mb-3">
                                            <label htmlFor="heading4">Heading</label>
                                            <input type="text" id="heading4" name="heading" className="form-control" value={carrerData?.heading} onChange={handleCarrerChange} />
                                        </div>

                                        <div className="form-group mb-3">
                                            <label htmlFor="description4">Description</label>
                                            <textarea id="description4" name="description" className="form-control" rows="3" value={carrerData?.description} onChange={handleCarrerChange}></textarea>
                                        </div>

                                        <div className='d-flex'>
                                            <div className="form-group mb-3 w-50">
                                                <label htmlFor="image">Image</label>
                                                <input
                                                    type="file"
                                                    id="image"
                                                    name="image"
                                                    className="form-control"
                                                    accept="image/*"
                                                    onChange={handleImage}
                                                />
                                            </div>
                                            {imageFile && (
                                                <div className="mx-5 d-flex align-item-center justify-content-center">
                                                    <img
                                                        className="mt-3"
                                                        alt="not found"
                                                        width={"100px"}
                                                        height={"100px"}
                                                        src={imageFile}
                                                        style={{ border: "1px solid #000", borderRadius: "10px", boxShadow: "0 10px 10px rgba(0,0,0,0.5)" }}
                                                    />
                                                    <span className="mt-2"
                                                        style={{ fontSize: "20px", cursor: "pointer" }}
                                                        onClick={() => handleRemoveImage()}
                                                    >
                                                        <i className="fa-solid fa-square-xmark" style={{ color: "#b40822" }}></i>
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className='d-flex justify-content-center'>
                                    <button type='submit' className='btn btn-outline-success w-75'>Update</button>
                                </div>
                            </form>
                            <hr />
                        </>
                    }

                    {carrerGetData && !isEdit && (
                        <div className="mt-5">
                            <h3>Career Data</h3>
                            <Table striped bordered hover responsive>
                                <thead>
                                    <tr>
                                        <th>Heading</th>
                                        <th>Description</th>
                                        <th>Image</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{carrerGetData?.heading || '-'}</td>
                                        <td>{carrerGetData?.description || '-'}</td>
                                        <td>
                                            {carrerGetData?.image ? (
                                                <img
                                                    alt="Banner"
                                                    width={"100px"}
                                                    height={"100px"}
                                                    src={carrerGetData?.image}
                                                    style={{ border: "1px solid #ddd", borderRadius: "8px" }}
                                                />
                                            ) : (
                                                '-'
                                            )}
                                        </td>
                                        <td>
                                            <FaEye
                                                style={{ cursor: "pointer", marginRight: "15px", color: "#007bff" }}
                                                onClick={handleViewDetails}
                                                title="View Details"
                                            />
                                            <FaEdit
                                                style={{ cursor: "pointer", color: "#28a745" }}
                                                onClick={handleEdit}
                                                title="Edit"
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </div>
                    )}

                    {/* Modal for Viewing Details */}
                    <Modal isOpen={modalOpen} toggle={toggleModal}>
                        <ModalHeader toggle={toggleModal}>Career Details
                            <span style={{
                                marginLeft: "299px",
                                cursor: "pointer"
                            }} onClick={() => { toggleModal() }}><FaTimes className='' style={{ marginTop: "-20px" }} /></span>
                        </ModalHeader>
                        <ModalBody>
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Field</th>
                                        <th>Value</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Heading</td>
                                        <td>{carrerGetData?.heading || '-'}</td>
                                    </tr>
                                    <tr>
                                        <td>Description</td>
                                        <td>{carrerGetData?.description || '-'}</td>
                                    </tr>
                                    <tr>
                                        <td>Image</td>
                                        <td>
                                            {carrerGetData?.image ? (
                                                <img
                                                    alt="Banner"
                                                    width={"100px"}
                                                    height={"100px"}
                                                    src={carrerGetData?.image}
                                                    style={{ border: "1px solid #ddd", borderRadius: "8px" }}
                                                />
                                            ) : (
                                                '-'
                                            )}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </ModalBody>
                        <Button color="secondary" onClick={toggleModal}>Close</Button>
                    </Modal>
                </section>
            </div>
        </div>
    )
}

export default Carrer